import styles from "./WarningForm.module.css";

import moment from "moment";

const WarningForm = ({ ticket, showDialog }) => {
  return (
    <div
      className={
        showDialog
          ? styles["warningVerticalGridModal"]
          : styles["warningVerticalGrid"]
      }
    >
      <div
        className={`
          ${styles["warningHeader"]} 
          ${styles["cell"]} 
          ${styles["bold"]}
          `}
      >
        <span>{ticket?.ticketNumber}</span>
        <span>{ticket?.incident?.ori?.oriName} WARNING</span>
      </div>
      <div
        className={`
          ${styles["warningLicenseNumber"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>LICENSE #</span>
        <span>{ticket?.driversLicense}</span>
      </div>
      <div
        className={`
          ${styles["warningLicenseState"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>STATE</span>
        <span>{ticket?.state?.name}</span>
      </div>
      <div
        className={`
          ${styles["warningLastName"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>LAST NAME/ORGANIZATION</span>
        <span>{ticket?.issuedTo?.personalAttribute?.lastName}</span>
      </div>
      <div
        className={`
          ${styles["warningFirstName"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>FIRST</span>
        <span>{ticket?.issuedTo?.personalAttribute?.firstName}</span>
      </div>
      <div
        className={`
          ${styles["warningMiddleInitial"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>MI</span>
        <span>
          {ticket?.issuedTo?.personalAttribute?.middleName?.charAt(0)}
        </span>
      </div>
      <div
        className={`
          ${styles["warningStreetAddress"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>STREET ADDRESS</span>
        <span>
          {ticket?.issuedToAddress?.streetNumber}{" "}
          {ticket?.issuedToAddress?.streetName}{" "}
          {ticket?.issuedToAddress?.unit
            ? "#" + ticket?.issuedToAddress?.unit
            : ""}
        </span>
      </div>
      <div
        className={`
          ${styles["warningCity"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>CITY</span>
        <span>{ticket?.issuedToAddress?.city}</span>
      </div>
      <div
        className={`
          ${styles["warningState"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>STATE</span>
        <span>{ticket?.issuedToAddress?.state}</span>
      </div>
      <div
        className={`
          ${styles["warningZip"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>ZIP</span>
        <span>{ticket?.issuedToAddress?.zip}</span>
      </div>
      <div
        className={`
          ${styles["warningDob"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>DOB</span>
        <span>
          {ticket?.issuedTo?.personalAttribute?.dob
            ? moment
                .utc(
                  ticket?.issuedTo?.personalAttribute?.dob,
                  "YYYY-MM-DD HH:mm:ss UTC"
                )
                .local()
                .format("MM-DD-YYYY")
            : ""}
        </span>
      </div>
      <div
        className={`
          ${styles["warningPlateNumber"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>REG #</span>
        <span>{ticket?.vehicle?.vehiclePlate?.name}</span>
      </div>
      <div
        className={`
          ${styles["warningVehicleState"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>STATE</span>
        <span>{ticket?.vehicle?.vehicleState?.name}</span>
      </div>
      <div
        className={`
          ${styles["warningVehicleYear"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>YEAR</span>
        <span>{ticket?.vehicle?.year}</span>
      </div>
      <div
        className={`
          ${styles["warningVehicleMake"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>MAKE</span>
        <span>{ticket?.vehicle?.vehicleMake?.name}</span>
      </div>
      <div
        className={`
          ${styles["warningVehicleModel"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>MODEL</span>
        <span>{ticket?.vehicle?.vehicleModel?.name}</span>
      </div>
      <div
        className={`
          ${styles["warningVehicleColor"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>COLOR</span>
        <span>{ticket?.vehicle?.vehicleColor?.name}</span>
      </div>
      <div
        className={`
          ${styles["warningVioDate"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>VIO. DATE</span>
        <span>
          {ticket?.violationDate
            ? moment
                .utc(ticket?.violationDate, "YYYY-MM-DD HH:mm:ss UTC")
                .local()
                .format("MM-DD-YYYY")
            : ""}
        </span>
      </div>
      <div
        className={`
          ${styles["warningTime"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>TIME</span>
        <span>
          {ticket?.violationDate
            ? moment
                .utc(ticket?.violationDate, "YYYY-MM-DD HH:mm:ss UTC")
                .local()
                .format("HH:mm")
            : ""}
        </span>
      </div>
      <div
        className={`
          ${styles["warningMunicipality"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>CITY/TOWN</span>
        <span>{ticket?.municipality?.name}</span>
      </div>
      <div
        className={`
          ${styles["warningHighway"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>HIGHWAY</span>
        <span>{ticket?.highway?.name}</span>
      </div>
      <div
        className={`
          ${styles["warningLandmark"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span>PLACE/LANDMARK</span>
        <span>{ticket?.ticketLocation?.name}</span>
      </div>
      <div
        className={`
          ${styles["warningInViolationOf"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span className={styles["borderBottom"]}>IN VIOLATION OF:</span>
        <span>
          {ticket?.ticketViolationPrototype?.fullName || ""}:{" "}
          {ticket?.ticketViolationPrototype?.title || ""}{" "}
          {ticket?.ticketViolationPrototype?.statute || ""}{" "}
          {ticket?.ticketViolationPrototype?.section || ""}
        </span>
      </div>
      <div
        className={`
          ${styles["warningDetails"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span className={styles["borderBottom"]}>DETAILS OF OFFENSE</span>
        <span>{ticket?.defendantActions}</span>
      </div>
      <div
        className={`
          ${styles["warningSignature"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span className={styles["borderBottom"]}>
          OFFICER/TROOPER SIGNATURE
        </span>
        <span>
          {ticket?.officer?.personalAttribute?.lastName
            ? ticket?.officer?.personalAttribute?.lastName + ","
            : ""}{" "}
          {ticket?.officer?.personalAttribute?.firstName}
        </span>
      </div>
      <div
        className={`
          ${styles["warningIncidentNumber"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
        `}
      >
        <span className={styles["borderBottom"]}>Case/Incident number:</span>
        <span>{ticket?.incident?.incidentNumber}</span>
      </div>
      <div
        className={`
          ${styles["warningFooter"]}
          ${styles["cell"]}
          ${styles["vertFlex"]}
          ${styles["centerAlign"]}
        `}
      >
          <span className={styles["bold"]}>&quot;Your Safety is Our Business&quot;</span>
      </div>
    </div>
  );
};

export default WarningForm;
